let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cECFd")).then(() => parcelRequire('11nza'));